import React from 'react';
import iconMapping from './iconMapping.js';
import styles from './Icon.scss.js';
import useLoadIconImage from '../hooks/useLoadIconImage.js';

const typedIconMapping = iconMapping;
/**
 * @deprecated See Base Component Library (https://nearpod-packages.gitlab-pages.nearpod.com/base-component-library/?path=/docs/library-icon--docs)
 */
const Icon = _ref => {
  let {
    icon,
    onFocus = () => {},
    onMouseOver = () => {},
    onMouseOut = () => {},
    onBlur = () => {},
    alt
  } = _ref;
  const {
    error,
    image
  } = useLoadIconImage(iconMapping[icon]?.file);
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement("span", null), image && /*#__PURE__*/React.createElement("img", {
    className: styles?.[typedIconMapping[icon].size],
    src: image,
    alt: alt !== undefined ? alt : `${iconMapping[icon].group} ${iconMapping[icon].name}`,
    onFocus,
    onMouseOver,
    onMouseOut,
    onBlur
  }));
};
var Icon$1 = Icon;

export { Icon$1 as default };
//# sourceMappingURL=Icon.js.map
